var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.04,
    height: 16.679,
    viewBox: "0 0 14.04 16.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M8.828,16.679H2.606A2.609,2.609,0,0,1,0,14.073V5.245A2.609,2.609,0,0,1,2.606,2.639H8.828a2.609,2.609,0,0,1,2.606,2.606v8.828A2.609,2.609,0,0,1,8.828,16.679ZM2.606,3.942a1.3,1.3,0,0,0-1.3,1.3v8.828a1.3,1.3,0,0,0,1.3,1.3H8.828a1.3,1.3,0,0,0,1.3-1.3V5.245a1.3,1.3,0,0,0-1.3-1.3Zm11.434,8.5V2.606A2.609,2.609,0,0,0,11.434,0H4.2a.652.652,0,1,0,0,1.3h7.232a1.3,1.3,0,0,1,1.3,1.3v9.838a.652.652,0,0,0,1.3,0Zm0,0",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.87f0eb53a272abda99bdd25110ff3d53.svg";
export { ForwardRef as ReactComponent };